<div *ngIf="!isWaitingForUpdate">
  <div *ngIf="!hasSuccessRouteFailed">
    <h1 class="heading">{{ params.heading }}</h1>

    <div class="text">
      {{ parameterizedSubHeading }}
    </div>
  </div>

  <div *ngIf="hasSuccessRouteFailed">
    <h1 class="heading">{{ successRouteFailedHeading }}</h1>

    <div class="text">{{ successRouteFailedSubHeading }} + {{ email }}</div>
  </div>

  <ng-container *ngIf="state.totalCheckoutValue">
    <zaver-button-link
      class="details-link"
      (click)="detailsClick()"
      [text]="'Details und Bedingungen ansehen'"
    ></zaver-button-link>
  </ng-container>
</div>
